// extracted by mini-css-extract-plugin
module.exports = {"deleteAll":"tag-list-component_deleteAll__1f-52"};